/* ============================================================
   NÜVO PDP — interactividad
   ------------------------------------------------------------
   Sólo cubre lo que assets/elegance-animations.js NO trae ya
   (reveal on-scroll, marquee infinito y fade de imágenes lazy
   siguen viviendo ahí — este archivo no los duplica):
   galería con flechas/miniaturas, acordeones exclusivos,
   barra de progreso de la línea de tiempo, selector de tiers,
   barra sticky, video con play-on-click, y notificación de
   compra (opt-in).
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Limpieza de ?view= heredado ----------
     La plantilla alterna product.nuvo-pdp-v2.json se borro el 2026-09-04
     (ver PDP-FUNNEL.md): esta PDP ya es la plantilla por defecto, y ya no
     queda ninguna alterna de producto en el theme. Shopify no puede
     devolver error por un ?view= que no reconoce — cae de vuelta a la
     plantilla por defecto en vez de romper la pagina — asi que la URL
     vieja (?view=nuvo-pdp-v2 o cualquier otra) se limpia aqui, del lado
     del cliente, apenas carga. No usa location.replace/reload: solo
     reescribe la barra de direcciones (misma pagina, mismo contenido). */
  (function limpiarViewHeredado() {
    if (!window.history || !window.history.replaceState) return;
    var params = new URLSearchParams(window.location.search);
    if (!params.has('view')) return;
    params.delete('view');
    var qs = params.toString();
    var url = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
    window.history.replaceState(window.history.state, '', url);
  })();

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
    document.addEventListener('shopify:section:load', fn);
  }

  /* ---------- Galería del hero ---------- */
  function initGallery(root) {
    var gal = root.querySelector('[data-nv-gallery]');
    if (!gal || gal.dataset.nvBound) return;
    gal.dataset.nvBound = '1';

    var slides = gal.querySelectorAll('.nv-hero__gal-slide');
    var thumbs = gal.querySelectorAll('[data-nv-thumb]');
    if (slides.length < 2) return;

    /* Avance automático (pedido de Nicolás, 2026-09-08): muy sutil, con
       crossfade (CSS) en vez de corte seco. Se detiene solo, sin
       "pausar y listo" a medias:
       - en hover/foco (el cliente está mirando esa imagen a propósito)
       - si la pestaña no está visible (no gasta ciclos de fondo)
       - si la slide activa es un video que está reproduciéndose
       - con prefers-reduced-motion
       Cada cambio de slide (automático O manual) reinicia el cronómetro
       desde show(), así tocar una miniatura nunca "salta" al siguiente
       auto-avance un instante después. */
    var AUTOPLAY_MS = 4500;
    var autoplayTimer = null;
    var autoplayPaused = false;
    var prefersReducedMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    function current() { return parseInt(gal.dataset.nvIndex || '0', 10); }

    function activeHasPlayingVideo() {
      var slide = slides[current()];
      if (!slide) return false;
      var video = slide.querySelector('video');
      return !!(video && !video.paused && !video.ended);
    }

    function stopAutoplay() {
      if (autoplayTimer) { clearTimeout(autoplayTimer); autoplayTimer = null; }
    }

    function scheduleAutoplay() {
      stopAutoplay();
      if (prefersReducedMotion || autoplayPaused || document.hidden) return;
      autoplayTimer = setTimeout(function () {
        if (!autoplayPaused && !document.hidden && !activeHasPlayingVideo()) {
          show((current() + 1) % slides.length);
        } else {
          scheduleAutoplay();
        }
      }, AUTOPLAY_MS);
    }

    function show(index) {
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
      gal.dataset.nvIndex = index;
      scheduleAutoplay();
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(parseInt(t.dataset.index, 10)); });
    });
    var prev = gal.querySelector('[data-nv-gal-prev]');
    var next = gal.querySelector('[data-nv-gal-next]');
    if (prev) prev.addEventListener('click', function () { show((current() - 1 + slides.length) % slides.length); });
    if (next) next.addEventListener('click', function () { show((current() + 1) % slides.length); });

    gal.addEventListener('mouseenter', function () { autoplayPaused = true; stopAutoplay(); });
    gal.addEventListener('mouseleave', function () { autoplayPaused = false; scheduleAutoplay(); });
    gal.addEventListener('focusin', function () { autoplayPaused = true; stopAutoplay(); });
    gal.addEventListener('focusout', function () { autoplayPaused = false; scheduleAutoplay(); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAutoplay(); else scheduleAutoplay();
    });

    /* swipe táctil */
    var startX = null;
    var main = gal.querySelector('.nv-hero__gal-main');
    main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) show(dx < 0 ? (current() + 1) % slides.length : (current() - 1 + slides.length) % slides.length);
      startX = null;
    });

    scheduleAutoplay();
  }

  /* ---------- Estrellas: entran una a una con brillo ----------
     Pedido de Nicolás (2026-09-08), "muy sutil". El Liquid sigue
     imprimiendo un solo <span class="nv-stars">★★★★★</span> (hero y
     recap de reseñas) -- acá se parte en 5 <span class="nv-star"> con un
     animation-delay escalonado, sin tocar ningún archivo .liquid. Corre
     una sola vez por elemento, al cargar. */
  function initStars(root) {
    root.querySelectorAll('.nv-stars').forEach(function (el) {
      if (el.dataset.nvBound) return;
      el.dataset.nvBound = '1';
      var chars = el.textContent.trim().split('');
      if (chars.length < 2) return;
      el.textContent = '';
      var frag = document.createDocumentFragment();
      chars.forEach(function (ch, i) {
        var span = document.createElement('span');
        span.className = 'nv-star';
        span.textContent = ch;
        span.style.animationDelay = (i * 0.12) + 's';
        frag.appendChild(span);
      });
      el.appendChild(frag);
    });
  }

  /* ---------- Conteo de reseñas: anima de 1 al total al cargar ----------
     Pedido de Nicolás (2026-09-08): que "357" se vea como "357+" y suba
     desde 1 al cargar la página, muy sutil. data-nv-count-reviews trae el
     número real (ya viene impreso por Liquid como fallback sin
     JS); acá se reemplaza por el conteo animado y se deja fijo en
     el numero exacto al terminar. */
  function initReviewCounters(root) {
    root.querySelectorAll('[data-nv-count-reviews]').forEach(function (el) {
      if (el.dataset.nvBound) return;
      el.dataset.nvBound = '1';
      var target = parseInt(el.dataset.nvCountReviews, 10);
      if (!target || isNaN(target)) return;

      var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReducedMotion) { el.textContent = String(target); return; }

      var duration = 1100;
      var startTime = null;
      function easeOutQuad(t) { return t * (2 - t); }
      function tick(ts) {
        if (startTime === null) startTime = ts;
        var progress = Math.min((ts - startTime) / duration, 1);
        var value = Math.round(1 + (target - 1) * easeOutQuad(progress));
        el.textContent = String(value);
        if (progress < 1) requestAnimationFrame(tick);
        else el.textContent = String(target);
      }
      requestAnimationFrame(tick);
    });
  }

  /* ---------- Acordeones exclusivos (sólo un panel abierto a la vez) ---------- */
  function initAccordion(root) {
    root.querySelectorAll('[data-nv-accordion]').forEach(function (group) {
      if (group.dataset.nvBound) return;
      group.dataset.nvBound = '1';
      var items = group.querySelectorAll('details');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (item.open) items.forEach(function (other) { if (other !== item) other.open = false; });
        });
      });
    });
  }

  /* ---------- Línea de tiempo: barra de progreso evergreen ----------
     data-nv-timeline vive en el viewport (nunca se clona -- el script de
     marquesina solo duplica el [data-marquee-track] de adentro), así que
     "weeks" se cuenta siempre sobre ESE track original y no sobre el clon
     aria-hidden, sin importar en qué orden corran los scripts. */
  function initTimeline(root) {
    root.querySelectorAll('[data-nv-timeline]').forEach(function (viewport) {
      if (viewport.dataset.nvBound) return;
      viewport.dataset.nvBound = '1';
      var section = viewport.closest('.nv-exp');
      var bar = section.querySelector('[data-nv-progress]');
      if (!bar) return;
      var track = viewport.querySelector('[data-marquee-track]');
      var weeks = (track ? track.querySelectorAll('.nv-exp__week').length : 0) || 1;
      /* Contenido evergreen: siempre arranca en "semana 1", nunca cuenta
         tiempo real desde una fecha — MARCA.md 4.3, nada de urgencia falsa. */
      var pct = Math.round(100 / (weeks * 4));
      requestAnimationFrame(function () { bar.style.width = pct + '%'; });
    });
  }

  /* ---------- Selector de tiers ---------- */
  function initTiers(root) {
    root.querySelectorAll('[data-nv-tiers]').forEach(function (wrap) {
      if (wrap.dataset.nvBound) return;
      wrap.dataset.nvBound = '1';
      wrap.addEventListener('change', function (e) {
        var radio = e.target.closest('[data-nv-tier-radio]');
        if (!radio) return;
        wrap.querySelectorAll('.nv-tier').forEach(function (label) { label.classList.remove('nv-tier--selected'); });
        radio.closest('.nv-tier').classList.add('nv-tier--selected');
        /* Nota: el precio del paquete es informativo. Conectar a una
           variante/selling plan real cuando el producto lo requiera. */
      });
      /* Pedido de Nicolás (2026-09-07): tocar la tarjeta de "Elige tu
         pedido" debe abrir el modal de EasySell, igual que el botón
         "Pedir contra entrega" de abajo. Se escucha 'click' y no
         'change' a propósito: con un solo paquete el radio ya viene
         marcado desde el schema (best_value → checked), así que 'change'
         nunca dispara al volver a tocar la misma tarjeta. openEasySell()
         está definida más abajo en este archivo (function declaration,
         disponible aquí por hoisting). */
      wrap.addEventListener('click', function (e) {
        if (!e.target.closest('.nv-tier')) return;
        openEasySell();
      });
    });
  }

  /* ---------- Vitrina de paquetes del hero (espejo de EasySell) ----------
     Solo vitrina: no calcula ni envía ninguna cantidad propia. Tocar
     cualquier tarjeta busca y clickea el BOTÓN REAL de EasySell (visible,
     dice "PEDIR CONTRA ENTREGA") -- nunca el formulario nativo oculto de
     Shopify, que jamás debe someterse (ver nv-atc-form más abajo y el
     comentario en nuvo-pdp-hero-buybox.liquid).

     CORREGIDO 2026-09-07 (v1): la primera versión clickeaba el botón
     nativo oculto asumiendo que EasySell lo interceptaba (con
     "cpb_button" activo, no lo hace) -- eso sometía el <form> de Shopify
     de verdad y mandaba al cliente al carrito nativo.

     CORREGIDO 2026-09-07 (v2): la v1 buscaba por el texto "PEDIR CONTRA
     ENTREGA", pero ese mismo texto también lo usan VARIOS botones propios
     del theme (banda CTA, línea de tiempo, "Elige tu pedido" -- todos
     `<a class="nv-btn" href="#nv-pdp-hero">`, solo hacen scroll al hero).
     El buscador encontraba uno de esos primero y por eso el click hacía
     scroll en vez de abrir el popup.

     CORREGIDO 2026-09-07 (v3): la v2 seguía sin funcionar -- el elemento
     real de EasySell NO es un <button> ni un <a>, es un <div
     id="es-popup-button" class="es-popup-button es-popup-button-product">
     (confirmado por Nicolás pegando su HTML real). La búsqueda de v2
     (`button, a, [role="button"]`) nunca lo iba a encontrar. Ahora se
     apunta directo a ese id/clase real, sin heurísticas de texto ni
     exclusiones. Se reintenta unos segundos por si su script (carga con
     defer/módulo) todavía no lo montó. */
  function findEasySellButton() {
    return document.getElementById('es-popup-button') ||
      document.querySelector('.es-popup-button-product') ||
      document.querySelector('.es-popup-button');
  }

  function openEasySell(tries) {
    tries = tries || 0;
    var btn = findEasySellButton();
    if (btn) { btn.click(); return; }
    if (tries < 20) setTimeout(function () { openEasySell(tries + 1); }, 250);
  }

  /* ---------- Espejo REAL de las ofertas de EasySell ----------
     Corregido 2026-09-08: hasta ahora "espejo" era texto editado a mano en
     el tema (tier1_price, tier2_price...) que copiaba lo que decía EasySell
     en el momento de escribirlo -- si Nicolás cambiaba algo en su panel,
     esto se quedaba con el número viejo. Eso no es un espejo, es una foto.

     La fuente real es `window.EASYSELL_QUANTITY_OFFERS`, una variable
     global que el propio script de EasySell escribe en el HTML de la
     página (confirmado leyendo el HTML servido, sin ejecutar JS, el
     2026-09-08) -- es la misma tabla que alimenta su popup real:
       [{ id, enabled, productIds: ["gid://shopify/Product/..."],
          offers: [{ id, title, label, badge, image, quantity,
                     discount: { type: "percentage", value }, preselected }] }]
     El precio final NO viene calculado ahí: se calcula igual que lo hace
     EasySell -- precio del producto (current_variant.price, ya en la
     página) × cantidad, menos el % de descuento. Así, cambiar el precio
     en Shopify O el % en el panel de EasySell actualiza cualquier tarjeta
     que use estas funciones, sin tocar nunca el tema. */

  function findEasySellOffersConfig(productGid) {
    var all = window.EASYSELL_QUANTITY_OFFERS;
    if (!Array.isArray(all) || !all.length) return null;
    for (var i = 0; i < all.length; i++) {
      var entry = all[i];
      if (entry && entry.enabled !== false && Array.isArray(entry.offers) && entry.offers.length &&
          Array.isArray(entry.productIds) && entry.productIds.indexOf(productGid) !== -1) {
        return entry;
      }
    }
    /* Respaldo: una tienda con una sola campaña de ofertas, sin
       productIds que calcen exacto (no debería pasar, pero mejor mostrar
       la única campaña real que dejar la vitrina vacía). */
    for (var j = 0; j < all.length; j++) {
      if (all[j] && all[j].enabled !== false && Array.isArray(all[j].offers) && all[j].offers.length) return all[j];
    }
    return null;
  }

  /* EasySell imprime su propio formato de moneda en window.ES_MONEY_FORMAT
     (ej. "${{amount}}"). Se reusa tal cual para que el número se vea
     idéntico al de su popup real, sin asumir "$" a mano. */
  function formatEsMoney(cents) {
    var amount = (Math.round(cents) / 100).toFixed(2);
    var fmt = window.ES_MONEY_FORMAT;
    if (typeof fmt === 'string' && fmt.indexOf('{{amount}}') !== -1) return fmt.replace('{{amount}}', amount);
    return '$' + amount;
  }

  /* Pide al CDN de Shopify una copia redimensionada de una imagen que ya
     viene como URL completa (con o sin query string propia, como el "?v="
     de versión de EasySell) -- mismo mecanismo que `image_url: width:` en
     Liquid, pero en JS, para imágenes que no pasan por ese filtro porque
     vienen de fuera del tema (EasySell). */
  function withImageWidth(url, width) {
    if (!url) return url;
    return url + (url.indexOf('?') !== -1 ? '&' : '?') + 'width=' + width;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* unitPriceCents = current_variant.price real, en centavos (Liquid).
     "par" = la unidad real del producto (1 unidad = 1 par = 2 plantillas,
     confirmado en la ficha del producto) -- quantity de la oferta ya
     cuenta pares, no plantillas sueltas. */
  function computeOfferDisplay(offer, unitPriceCents) {
    var qty = parseInt(offer.quantity, 10) || 1;
    var baseCents = unitPriceCents * qty;
    var pct = 0;
    if (offer.discount && offer.discount.type === 'percentage') pct = parseFloat(offer.discount.value) || 0;
    var finalCents = Math.round(baseCents * (1 - (pct / 100)));
    return {
      title: offer.title || '',
      label: offer.label || '',
      badge: offer.badge || '',
      image: offer.image || '',
      quantity: qty,
      preselected: !!offer.preselected,
      price: formatEsMoney(finalCents),
      comparePrice: pct > 0 ? formatEsMoney(baseCents) : '',
      unitPrice: qty > 1 ? formatEsMoney(Math.round(finalCents / qty)) : ''
    };
  }

  /* ---------- Cualquier "Pedir..." de la página abre EasySell ----------
     Pedido de Nicolás (2026-09-07): todo botón de pedir debe tener el
     mismo efecto que "PEDIR CONTRA ENTREGA" -- abrir el modal real de
     EasySell, no solo saltar al hero. Estos CTA están repartidos en
     varios bloques (banda CTA, línea de tiempo, "Elige tu pedido"), todos
     apuntando por defecto a "#nv-pdp-hero" -- se intercepta a nivel de
     documento (delegación) en vez de editar cada bloque, así cualquier
     CTA nuevo con ese mismo enlace queda cubierto automáticamente. */
  function initGlobalPedirCtas() {
    if (document.body.dataset.nvPedirBound) return;
    document.body.dataset.nvPedirBound = '1';
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a.nv-btn[href="#nv-pdp-hero"]');
      if (!link) return;
      e.preventDefault();
      openEasySell();
    });
  }

  function bindBundleClicks(bundle) {
    var opts = bundle.querySelectorAll('[data-nv-bundle-open]');
    opts.forEach(function (opt) {
      opt.addEventListener('click', function () {
        opts.forEach(function (o) { o.classList.remove('is-active'); });
        opt.classList.add('is-active');
        openEasySell();
      });
    });
  }

  /* Arma las 3 tarjetas desde la oferta real -- nace oculta ([hidden] en
     el Liquid) y solo se revela cuando ya tiene datos de verdad que
     mostrar. Si EasySell nunca responde (app caída/desinstalada), se
     queda oculta para siempre: mejor no mostrar la vitrina que mostrar un
     precio inventado. */
  function renderBundleFromEasySell(bundle, tries) {
    tries = tries || 0;
    var unitPriceCents = parseInt(bundle.dataset.nvUnitPrice, 10);
    var productGid = bundle.dataset.nvProductGid;
    var config = findEasySellOffersConfig(productGid);
    if (!config || !unitPriceCents) {
      if (tries < 20) { setTimeout(function () { renderBundleFromEasySell(bundle, tries + 1); }, 250); return; }
      return; /* se queda oculta */
    }

    bundle.innerHTML = '';
    config.offers.forEach(function (offer) {
      var d = computeOfferDisplay(offer, unitPriceCents);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'nv-bundle__opt' + (d.preselected ? ' is-active' : '');
      btn.setAttribute('data-nv-bundle-open', '');
      var html = '';
      if (d.label) html += '<span class="nv-bundle__badge' + (d.preselected ? '' : ' nv-bundle__badge--dark') + '">' + escapeHtml(d.label) + '</span>';
      /* &width=200 -- la imagen real de EasySell pesa ~470KB a tamaño
         original (foto subida a su panel, no un thumbnail); acá se ve a
         84px, así que se pide una copia redimensionada por el CDN de
         Shopify, igual que hace el propio popup de EasySell con la suya. */
      if (d.image) html += '<span class="nv-bundle__img"><img src="' + escapeHtml(withImageWidth(d.image, 200)) + '" alt="' + escapeHtml(d.title) + '" width="160" height="160" loading="lazy"></span>';
      html += '<span class="nv-bundle__title">' + escapeHtml(d.title) + '</span>';
      if (d.badge) html += '<span class="nv-bundle__save' + (d.preselected ? ' nv-bundle__save--active' : '') + '">' + escapeHtml(d.badge) + '</span>';
      html += '<span class="nv-bundle__price">' + d.price + (d.comparePrice ? ' <s class="nv-bundle__compare">' + d.comparePrice + '</s>' : '') + '</span>';
      if (d.unitPrice) html += '<span class="nv-bundle__unit">' + d.unitPrice + ' c/par</span>';
      btn.innerHTML = html;
      bundle.appendChild(btn);
    });

    /* CORREGIDO 2026-09-08: las imágenes no se veían -- elegance-custom.css
       trae una regla global, `img[loading="lazy"] { opacity: 0 }`, que solo
       se revela agregando la clase "is-loaded" (confirmado viendo el HTML
       real que pegó Nicolás: sus <img> del carrusel SÍ traían esa clase).
       Esa clase la agrega el propio tema al cargar la página, para las
       imágenes que YA existen en ese momento -- las que esta función
       inserta después, dinámicas, nunca pasan por ese barrido y se quedan
       en opacity:0 para siempre. Se resuelve acá mismo, sin depender de
       ningún script ajeno: al terminar de cargar (o si ya estaba en
       caché) cada <img> nueva, se le agrega la clase directo. */
    bundle.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      if (img.complete) { img.classList.add('is-loaded'); return; }
      img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
      img.addEventListener('error', function () { img.classList.add('is-loaded'); }, { once: true });
    });

    bindBundleClicks(bundle);
    bundle.hidden = false;
    var heading = bundle.parentElement && bundle.parentElement.querySelector('[data-nv-bundle-heading]');
    if (heading) heading.hidden = false;
  }

  function initBundleShowcase(root) {
    root.querySelectorAll('[data-nv-bundle]').forEach(function (bundle) {
      if (bundle.dataset.nvBound) return;
      bundle.dataset.nvBound = '1';
      renderBundleFromEasySell(bundle);
    });

    /* Blindaje: el <form> nativo se queda en el DOM como ancla, pero
       jamás debe enviarse por ninguna vía (click perdido, Enter, etc.).
       Todo el proceso de compra lo maneja EasySell. */
    var nativeForm = document.getElementById('nv-atc-form');
    if (nativeForm && !nativeForm.dataset.nvGuarded) {
      nativeForm.dataset.nvGuarded = '1';
      nativeForm.addEventListener('submit', function (e) { e.preventDefault(); });
    }
  }

  /* ---------- "Elige tu pedido": la tarjeta con mirror_easysell_offer ----------
     Mismo mecanismo que la vitrina del hero, aplicado a la tarjeta única
     de la sección de más abajo (pedido de Nicolás, 2026-09-07: que
     mostrara la mejor oferta real). Solo actúa si el bloque trae
     data-nv-mirror-easysell="true" -- el tipo de bloque "tier" es
     genérico y reutilizable para cualquier producto futuro, así que el
     espejo automático es opt-in, no el comportamiento por defecto.
     Si EasySell no responde, se queda con el texto que ya imprimió
     Liquid (los campos de la sección, pensados como respaldo). */
  function initTierMirror(root) {
    root.querySelectorAll('[data-nv-tiers]').forEach(function (wrap) {
      if (wrap.dataset.nvMirrorBound) return;
      wrap.dataset.nvMirrorBound = '1';
      var mirrorTier = wrap.querySelector('.nv-tier[data-nv-mirror-easysell="true"]');
      if (mirrorTier) renderTierMirror(wrap, mirrorTier);
    });
  }

  function renderTierMirror(wrap, tierEl, tries) {
    tries = tries || 0;
    var unitPriceCents = parseInt(wrap.dataset.nvUnitPrice, 10);
    var productGid = wrap.dataset.nvProductGid;
    var config = findEasySellOffersConfig(productGid);
    if (!config || !unitPriceCents) {
      if (tries < 20) { setTimeout(function () { renderTierMirror(wrap, tierEl, tries + 1); }, 250); return; }
      return; /* se queda con el respaldo que ya imprimió Liquid */
    }

    var offer = null;
    for (var i = 0; i < config.offers.length; i++) {
      if (config.offers[i].preselected) { offer = config.offers[i]; break; }
    }
    if (!offer) offer = config.offers[0];
    if (!offer) return;
    var d = computeOfferDisplay(offer, unitPriceCents);

    var badgeEl = tierEl.querySelector('.nv-tier__badge');
    if (badgeEl && d.label) badgeEl.textContent = d.label;
    var imgEl = tierEl.querySelector('img');
    if (imgEl && d.image) {
      imgEl.src = withImageWidth(d.image, 300);
      imgEl.alt = d.title;
      /* Blindaje igual al de la vitrina del hero: si por timing esta
         imagen aún no tenía la clase "is-loaded" que la revela (ver
         elegance-custom.css), no se queda esperando un "load" que ya
         pasó para el src viejo. */
      if (imgEl.complete) imgEl.classList.add('is-loaded');
      else imgEl.addEventListener('load', function () { imgEl.classList.add('is-loaded'); }, { once: true });
    }
    var nameEl = tierEl.querySelector('.nv-tier__name');
    if (nameEl && d.title) nameEl.textContent = d.title;
    var subEl = tierEl.querySelector('.nv-tier__sub');
    /* "par" = la unidad real del producto (1 par = 2 plantillas, ficha del
       producto) -- quantity de la oferta ya cuenta pares. */
    if (subEl) subEl.textContent = d.quantity + (d.quantity === 1 ? ' par · 2 plantillas' : ' pares · ' + (d.quantity * 2) + ' plantillas');
    var saveEl = tierEl.querySelector('.nv-tier__save');
    if (saveEl && d.badge) saveEl.textContent = d.badge;
    var priceEl = tierEl.querySelector('.nv-tier__price');
    if (priceEl) priceEl.innerHTML = d.price + (d.comparePrice ? ' <s>' + d.comparePrice + '</s>' : '');
    var unitEl = tierEl.querySelector('.nv-tier__unit');
    if (unitEl) { if (d.unitPrice) { unitEl.hidden = false; unitEl.textContent = d.unitPrice + ' c/par'; } else { unitEl.hidden = true; } }
    var radio = tierEl.querySelector('[data-nv-tier-radio]');
    if (radio) { radio.dataset.price = d.price; radio.dataset.compare = d.comparePrice; }
  }

  /* ---------- Video: click-to-play con sonido ---------- */
  function initVideoCards(root) {
    root.querySelectorAll('[data-nv-video-card]').forEach(function (card) {
      if (card.dataset.nvBound) return;
      card.dataset.nvBound = '1';
      var video = card.querySelector('video');
      var btn = card.querySelector('[data-nv-video-play]');
      if (!video || !btn) return;
      btn.addEventListener('click', function () {
        if (video.paused) {
          video.muted = false;
          video.play();
          btn.hidden = true;
        } else {
          video.pause();
          btn.hidden = false;
        }
      });
      video.addEventListener('pause', function () { btn.hidden = false; });
      video.addEventListener('ended', function () { btn.hidden = false; });
    });
  }

  /* ---------- Reseñas: "Ver más" solo cuando el texto de verdad desborda ----------
     El botón nace [hidden] en el Liquid. Acá se mide si el párrafo
     recortado (3 líneas, CSS) desborda su propia altura -- si el texto es
     corto y nunca llegó a recortarse, el botón se queda oculto (nunca un
     "Ver más" que al abrirlo no cambia nada). */
  function initReviewMore(root) {
    root.querySelectorAll('[data-nv-review-text]').forEach(function (p) {
      var btn = p.nextElementSibling;
      if (!btn || !btn.hasAttribute('data-nv-review-more') || btn.dataset.nvBound) return;
      btn.dataset.nvBound = '1';
      if (p.scrollHeight <= p.clientHeight + 1) return; /* no desborda: no hace falta el botón */
      btn.hidden = false;
      btn.addEventListener('click', function () {
        var expanded = p.classList.toggle('is-expanded');
        btn.textContent = expanded ? 'Ver menos' : 'Ver más';
      });
    });
  }

  /* ---------- Barra sticky móvil ---------- */
  function initSticky(root) {
    root.querySelectorAll('[data-nv-sticky]').forEach(function (bar) {
      if (bar.dataset.nvBound) return;
      bar.dataset.nvBound = '1';
      bar.hidden = false; /* se controla con la clase is-visible, no con [hidden] */
      var threshold = parseInt(bar.dataset.showAfter, 10) || 600;
      var ticking = false;
      /* La barra duplica el CTA del hero y el del mini-footer: mostrarla
         ahí encima no agrega nada y en pantallas cortas le tapa el botón
         de verdad o los enlaces del footer. Se apaga mientras cualquiera
         de los dos está a la vista, usando el mismo scroll listener en
         vez de un IntersectionObserver aparte para no sumar overhead. */
      var heroCta = document.querySelector('#nv-atc-form');
      var footer = document.querySelector('.nv-foot');
      function isOnScreen(el) {
        if (!el) return false;
        var r = el.getBoundingClientRect();
        return r.bottom > 0 && r.top < window.innerHeight;
      }
      function update() {
        var pastThreshold = window.scrollY > threshold;
        var nearCtaOrFooter = isOnScreen(heroCta) || isOnScreen(footer);
        bar.classList.toggle('is-visible', pastThreshold && !nearCtaOrFooter);
        ticking = false;
      }
      window.addEventListener('scroll', function () {
        if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
      }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Barra de promoción (countdown real) ----------
     MARCA.md 4.3: "si hay contador, la oferta termina de verdad cuando
     el contador llega a cero". Por eso esto no solo pinta ceros al
     terminar: oculta la barra entera y para el intervalo, para siempre
     (hasta que alguien suba una ends_at nueva). Igual se oculta de una
     si ends_at viene vacía o mal formada, en vez de mostrar "NaN". */
  function initCountdown(root) {
    root.querySelectorAll('[data-nv-countdown]').forEach(function (el) {
      if (el.dataset.nvBound) return;
      el.dataset.nvBound = '1';

      var endsAt = new Date(el.dataset.endsAt).getTime();
      if (!endsAt || isNaN(endsAt)) { el.hidden = true; return; }

      var dEl = el.querySelector('[data-nv-cd="d"]');
      var hEl = el.querySelector('[data-nv-cd="h"]');
      var mEl = el.querySelector('[data-nv-cd="m"]');
      var sEl = el.querySelector('[data-nv-cd="s"]');
      var pad = function (n) { return String(n).padStart(2, '0'); };
      var timer = null;

      function tick() {
        var diff = endsAt - Date.now();
        if (diff <= 0) {
          clearInterval(timer);
          el.hidden = true;
          return;
        }
        var totalSeconds = Math.floor(diff / 1000);
        var days = Math.floor(totalSeconds / 86400);
        var hours = Math.floor((totalSeconds % 86400) / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;
        if (dEl) dEl.textContent = pad(days);
        if (hEl) hEl.textContent = pad(hours);
        if (mEl) mEl.textContent = pad(minutes);
        if (sEl) sEl.textContent = pad(seconds);
      }

      tick();
      timer = setInterval(tick, 1000);
    });
  }

  /* ---------- Notificación de compra reciente (opt-in, datos reales) ---------- */
  function initProof(root) {
    root.querySelectorAll('[data-nv-proof]').forEach(function (el) {
      if (el.dataset.nvBound) return;
      var names = (el.dataset.names || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
      var cities = (el.dataset.cities || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
      if (!names.length || !cities.length) return; /* nada que mostrar: no se inventa data */
      el.dataset.nvBound = '1';

      var first = (parseFloat(el.dataset.first) || 8) * 1000;
      var gap = (parseFloat(el.dataset.gap) || 15) * 1000;
      var hold = (parseFloat(el.dataset.hold) || 6) * 1000;
      var product = el.dataset.product || '';
      var textEl = el.querySelector('.nv-proof__text');
      var i = 0;

      function showNext() {
        var name = names[i % names.length];
        var city = cities[i % cities.length];
        i++;
        textEl.textContent = name + ' en ' + city + ' ' + product;
        el.hidden = false;
        requestAnimationFrame(function () { el.classList.add('is-visible'); });
        setTimeout(function () {
          el.classList.remove('is-visible');
          setTimeout(function () { el.hidden = true; }, 300);
        }, hold);
      }

      setTimeout(function () {
        showNext();
        setInterval(showNext, gap);
      }, first);
    });
  }

  function init() {
    /* La barra de promoción (data-nv-countdown) puede vivir fuera de
       .nv-pdp: desde 2026-09-04 se renderiza en el layout global, arriba
       del header, así que se inicializa sobre document entero. */
    initCountdown(document);
    initGlobalPedirCtas();

    document.querySelectorAll('.nv-pdp').forEach(function (root) {
      initGallery(root);
      initAccordion(root);
      initTimeline(root);
      initTiers(root);
      initTierMirror(root);
      initBundleShowcase(root);
      initVideoCards(root);
      initReviewMore(root);
      initSticky(root);
      initProof(root);
      initStars(root);
      initReviewCounters(root);
    });
  }

  onReady(init);
})();
